import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[paceCoreNumberOnly]',
    standalone: false,
    host: {
        '(paste)': 'blockPaste($event)',
        '(copy)': 'blockCopy($event)',
        '(cut)': 'blockCut($event)',
        '(keydown)': 'onKeyDownEvent($event)',
    },
})
export class NumberOnlyDirective {
    @Input() public maxLength: number;
    @Input() public maxValue: number;

    // eslint-disable-next-line
    public blockPaste(e: KeyboardEvent) {
        e.preventDefault();
    }

    // eslint-disable-next-line
    public blockCopy(e: KeyboardEvent) {
        e.preventDefault();
    }

    // eslint-disable-next-line
    public blockCut(e: KeyboardEvent) {
        e.preventDefault();
    }
    public constructor(private el: ElementRef) {}

    public onKeyDownEvent(event: KeyboardEvent): boolean | undefined {
        if (
            event.key === 'Backspace' ||
            event.key === 'Delete' ||
            event.key === 'ArrowLeft' ||
            event.key === 'ArrowRight' ||
            event.key === 'Tab'
        ) {
            return;
        }
        // additional check, since html5 input number allow dashes
        if (event.key === '-') {
            return false;
        }
        const nativeEl = <HTMLInputElement>this.el.nativeElement;
        const numberOnlyPattern = this.maxLength ? '^[0-9]{0,' + this.maxLength.toString() + '}$' : '^[0-9]$';
        const toMatchValue = nativeEl.value + event.key;
        const keyValue = +event.key;
        const newValue =
            nativeEl.selectionStart === 0
                ? (isNaN(keyValue) ? '' : keyValue.toString()) + nativeEl.value
                : nativeEl.value + (isNaN(keyValue) ? '' : keyValue.toString());
        const regexTest = new RegExp(numberOnlyPattern).test(toMatchValue);
        if (this.maxValue) {
            return regexTest && +newValue <= this.maxValue;
        }
        return regexTest;
    }
}
